import * as React from 'react'
import { Redirect as RouterRedirect } from 'react-router-dom'

export const Redirect404 = ({ pathname = '/not-found' }) => (
  <RouterRedirect
    to={{
      pathname,
    }}
  />
)
